export function getFirstErrorMessage(errors?: readonly unknown[]) {
    const firstError = errors?.[0];

    if (typeof firstError === "string") {
        return firstError;
    }

    if (
        firstError &&
        typeof firstError === "object" &&
        typeof (firstError as { message?: unknown }).message === "string"
    ) {
        return (firstError as { message: string }).message;
    }

    return undefined;
}
